import { api } from './axios';
import { transformToParamsString } from './utils';
import router from '@/router';

export default {
  async get(payload) {
    var config = {
      headers: { ...payload.headers }
    };
    if (payload.setToken) {
      config.headers['Authorization'] = `Bearer ${localStorage.getItem(
        'token'
      )}`;
    }
    let { query } = payload;
    query = transformToParamsString(query);
    return new Promise((resolve, reject) => {
      api
        .get(`${payload.path}${query}`, config)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('token');
            router.push({ name: 'login' });
          }
          reject(error);
        });
    });
  },
  async post(payload) {
    var config = {
      headers: { ...payload.headers }
    };
    if (payload.setToken) {
      config.headers['Authorization'] = `Bearer ${localStorage.getItem(
        'token'
      )}`;
    }
    let { query } = payload;
    query = transformToParamsString(query);
    return new Promise((resolve, reject) => {
      api
        .post(`${payload.path}${query}`, payload.body, config)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            // Redirige al login si el error es 401
            localStorage.removeItem('token'); // Elimina el token almacenado
            router.push({ name: 'login' }); // Redirige al login
          }
          reject(error);
        });
    });
  },
  async getFile(payload) {
    var config = { responseType: 'arraybuffer' };
    if (payload.setToken) {
      config.headers = {};
      config.headers['Authorization'] = `Bearer ${localStorage.getItem(
        'token'
      )}`;
    }
    let { query } = payload;
    query = transformToParamsString(query);
    return new Promise((resolve, reject) => {
      api
        .get(`${payload.path}${query}`, config)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            // Redirige al login si el error es 401
            localStorage.removeItem('token'); // Elimina el token almacenado
            router.push({ name: 'login' }); // Redirige al login
          }
          reject(error);
        });
    });
  },
  async getFilePost(payload) {
    var config = { responseType: 'arraybuffer' };
    if (payload.setToken) {
      config.headers = {};
      config.headers['Authorization'] = `Bearer ${localStorage.getItem(
        'token'
      )}`;
    }
    let { query } = payload;
    query = transformToParamsString(query);
    return new Promise((resolve, reject) => {
      api
        .post(`${payload.path}${query}`, payload.body, config)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            // Redirige al login si el error es 401
            localStorage.removeItem('token'); // Elimina el token almacenado
            router.push({ name: 'login' }); // Redirige al login
          }
          reject(error);
        });
    });
  },
  async delete(payload) {
    var config = {
      headers: { ...payload.headers }
    };
    if (payload.setToken) {
      config.headers['Authorization'] = `Bearer ${localStorage.getItem(
        'token'
      )}`;
    }
    let { query } = payload;
    query = transformToParamsString(query);
    return new Promise((resolve, reject) => {
      api
        .delete(`${payload.path}${query}`, config)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            // Redirige al login si el error es 401
            localStorage.removeItem('token'); // Elimina el token almacenado
            router.push({ name: 'login' }); // Redirige al login
          }
          reject(error);
        });
    });
  }
};
